<template>
    <div class="outer-container fontReg">
        <div class="left-container">
            <div class="top-left-container">
                <div class="icon-container">
                    <v-img :src="require('../assets/stax.png')" alt="Stax Analytics Logo"></v-img>
                </div>
                <div class="name-container">
                    <p class="name">Stax Analytics</p>
                </div>
            </div>
            <v-img :src="require('../assets/top-right-ellipsis.svg')"
                style="position:absolute;width:12rem;height:10rem;top:0;right:0;"></v-img>
            <v-img :src="require('../assets/cardEllipsis.svg')" class="card-ellipsis"></v-img>
            <div class="center-card">
                <div>
                    <p class="card-title">Transform Data into Actionable Insights</p>
                </div>
                <div>
                    <p class="card-body">
                        Unlock the power of your data with advanced analytics and real-time business intelligence
                    </p>
                </div>
            </div>
            <v-img :src="require('../assets/down-left-ellipse.svg')"
                style="position:absolute;width:20.2rem;height:20.7rem;bottom:-8%;"></v-img>
        </div>
        <div class="right-container">
            <div class="form-container">
                <div class="start-container">
                    <h1 class="start-title">Get Started</h1>
                    <p class="start-subtitle">Please enter your details to continue</p>
                </div>
                <div class="google-login-container" 
                    @click="signInWithGoogle()"
                    role="button"
                    tabindex="0"
                    @keydown.enter="signInWithGoogle()">
                    <div class="google-icon">
                        <v-img src="../assets/google_icon.svg" alt="Google Icon"></v-img>
                    </div>
                    <div>
                        <p class="google-login-font">Login with Google</p>
                    </div>
                </div>
                <div v-if="error" class="error-message">
                    <v-alert
                        type="error"
                        variant="tonal"
                        :text="error"
                    ></v-alert>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import { authService } from '@/services/authService';

export default {
    setup() {
        const router = useRouter();
        const loading = ref(false);
        const error = ref(null);

        onMounted(() => {
            // Check if user is already logged in
            const token = localStorage.getItem('auth_token');
            if (token) {
                router.push({ name: "HomeView" });
            }

            // Check for stored auth error
            const authError = localStorage.getItem('auth_error');
            if (authError) {
                error.value = authError;
                localStorage.removeItem('auth_error');
            }
        });

        const signInWithGoogle = async () => {
            try {
                loading.value = true;
                error.value = null;
                
                const result = await authService.signInWithGoogle();
                if (result.success) {
                    router.push({ name: "HomeView" });
                }
            } catch (err) {
                if (err.code === 'auth/popup-closed-by-user' || 
                    err.code === 'auth/cancelled-popup-request') {
                    return;
                }
                error.value = err.message;
            } finally {
                loading.value = false;
            }
        };

        return {
            signInWithGoogle,
            loading,
            error
        };
    },
};
</script>

<style scoped>
.outer-container {
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #2c3e50;
}

.left-container {
    width: 50%;
    height: 100%;
    overflow: hidden;
    position: relative;
    padding: 2rem 3rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.right-container {
    width: 50%;
    background: #fff;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100vh;
}

.top-left-container {
    display: flex;
    gap: 1.5rem;
    align-items: center;
    margin-bottom: 2rem;
    position: absolute;
    top: 2rem;
    left: 3rem;
}

.icon-container {
    width: 4rem;
    height: 4rem;
    border-radius: 50%;
    overflow: hidden;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.name {
    color: var(--theme-white, #fff);
    font-size: 1.75rem;
    font-weight: 600;
    line-height: 1.2;
    letter-spacing: 0.5px;
}

.center-card {
    display: flex;
    flex-direction: column;
    gap: 1.25rem;
    align-items: flex-start;
    border-radius: 1.5rem;
    background: rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(25px);
    padding: 2.5rem;
    margin: 0 auto;
    position: relative;
    max-width: 90%;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
    border: 1px solid rgba(255, 255, 255, 0.1);
}

.card-title {
    color: #fff;
    font-size: 1.75rem;
    font-weight: 600;
    line-height: 1.2;
    margin: 0;
    letter-spacing: 0.3px;
}

.card-body {
    color: rgba(255, 255, 255, 0.95);
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    margin: 0;
    letter-spacing: 0.2px;
}

.card-ellipsis {
    width: 9rem;
    height: 9rem;
    transform: rotate(150deg);
    left: 55%;
    top: 41%;
    position: absolute;
}

@media (max-width: 1920px) {
    .center-card {
        padding: 2rem;
        margin: 0 1.5rem;
    }
    
    .card-title {
        font-size: 1.5rem;
    }
    
    .card-body {
        font-size: 0.95rem;
    }
}

@media (max-width: 1200px) {
    .center-card {
        padding: 1.75rem;
        margin: 0 1.25rem;
    }
    
    .card-title {
        font-size: 1.4rem;
    }
    
    .card-body {
        font-size: 0.9rem;
    }
}

.bottom-curve {
    width: 458px;
    height: 458px;
    border-radius: 458px;
    opacity: 0.2;
    background: #a2dbfd;
    right: 100%;
    position: absolute;
    margin-top: 57%;
    transform: translate(50%, 48%);
}

@media (max-width: 1920px) {
    .bottom-curve {
        margin-top: 50%;
    }
}

.bottom-curve-two {
    width: 330px;
    height: 330px;
    border-radius: 458px;
    opacity: 0.2;
    background: #a2dbfd;
    position: absolute;
    margin-top: 65%;
    transform: translate(10%, 55%);
}

@media (max-width: 1920px) {
    .bottom-curve-two {
        margin-top: 60%;
    }
}

.form-container {
    width: min(90%, 400px);
    padding: 2rem;
    animation: fadeIn 0.6s ease-out;
    margin: 0;
}

.logo-container {
    margin-bottom: 1.5rem;
    display: flex;
    justify-content: flex-start;
    width: 100%;
    margin-left: 8px;
}

.logo-img {
    height: 45px;
    width: auto;
}

.start-container {
    margin-bottom: 2rem;
    width: 100%;
}

.start-title {
    color: #212332;
    font-size: 28px;
    font-weight: 600;
    line-height: 1.2;
    margin: 0 0 0.5rem 0;
}

.start-subtitle {
    color: #6F717E;
    font-size: 16px;
    font-weight: 400;
    line-height: 1.5;
    margin: 0;
}

.google-login-container {
    border-radius: 8px;
    border: 1.5px solid #E0E0E0;
    background: #fff;
    padding: 0.8rem 1.2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1.25rem;
    width: 100%;
    cursor: pointer;
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
    margin-bottom: 1.5rem;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.google-login-container:hover {
    background: #f8f9fa;
    border-color: #2c3e50;
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.google-login-container:hover .google-login-font {
    color: #2c3e50;
}

.google-login-container:active {
    transform: translateY(0);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.google-icon {
    width: 25px;
    height: 25px;
}

.google-login-font {
    color: #333;
    font-size: 16px;
    font-weight: 500;
    line-height: 1.5;
    margin: 0;
    letter-spacing: 0.3px;
}

.error-message {
    margin-top: 1.5rem;
}

@keyframes fadeIn {
    from { opacity: 0; transform: translateY(20px); }
    to { opacity: 1; transform: translateY(0); }
}

@media (max-width: 1200px) {
    .left-container, .right-container {
        width: 100%;
    }
    
    .left-container {
        display: none;
    }
}

@media (max-width: 768px) {
    .form-container {
        width: 95%;
        padding: 1.5rem;
    }
}

.google-login-container:focus-visible {
    outline: 2px solid #1976D2;
    outline-offset: 2px;
}

.v-btn {
    background-color: #2c3e50 !important;
    color: #fff !important;
    text-transform: none;
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 0.5px;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
}

.v-btn:hover {
    background-color: #34495e !important;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.v-btn:active {
    transform: translateY(0);
}
</style>